import { render, staticRenderFns } from "./CheckObjectMultiLocInput.vue?vue&type=template&id=23adccdf"
import script from "./CheckObjectMultiLocInput.vue?vue&type=script&lang=js"
export * from "./CheckObjectMultiLocInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports